import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBook2Fill = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 16 20",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M0 3C0 1.34315 1.34315 0 3 0H14C15.1046 0 16 0.89543 16 2V14.99C16 15.1576 15.9623 15.3115 15.8872 15.4617L15.3416 16.5528C15.2009 16.8343 15.2009 17.1657 15.3416 17.4472L15.8854 18.5348C15.9586 18.6737 16 18.832 16 19C16 19.5523 15.5523 20 15 20H3C1.34315 20 0 18.6569 0 17V3ZM3 16H13.4076C13.1789 16.6468 13.1789 17.3532 13.4076 18H3C2.44772 18 2 17.5523 2 17C2 16.4477 2.44772 16 3 16ZM6 5C5.44772 5 5 5.44772 5 6C5 6.55228 5.44772 7 6 7H10C10.5523 7 11 6.55228 11 6C11 5.44772 10.5523 5 10 5H6Z",
		fillRule: "evenodd",
		clipRule: "evenodd",
		fill: "currentColor"
	})
});
export default SvgBook2Fill;
